import script from "./LectorCodeViewer.vue?vue&type=script&lang=ts&setup=true"
export * from "./LectorCodeViewer.vue?vue&type=script&lang=ts&setup=true"

import "./LectorCodeViewer.vue?vue&type=style&index=0&id=70a18466&scoped=true&lang=less"

import exportComponent from "/home/gibo/development/primakurzyonline.cz-screencast/trunk/lector-code/pko-lector-code-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70a18466"]])

export default __exports__